import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import * as R from 'ramda';
import { getManagementState, ManagementState } from '../management.reducer';
import { adapter, MasterMenuState } from './master-menu-system.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';
import {SearchFilter} from '@emm/core/models/search-filter';

const getState = createSelector(getManagementState, (state: ManagementState) => state.masterMenu);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getInitSize = createSelector(getState, (state: MasterMenuState) => state.initSize);
const getSelectedTag = createSelector(getState, (state: MasterMenuState) => state.selectedRevote.tag);
const getAllLocations = createSelector(getState, (state: MasterMenuState) => state.locations);
const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedTag,
    (entities, selectedTag) => selectedTag && entities[selectedTag]
);
const getAllCategories = createSelector(getState, getSelected, (state: MasterMenuState, selected) => {
  let categories = [];
  let selectedCategoriesCheck = false;
  if (RA.isNotUndefined(selected) && R.isNotEmpty(selected) && RA.isNotNull(selected)) {
    for (let i = 0; i < state.category.length; i++) {
      for (let j = 0; j < selected.submenus.length; j++) {
        if (state.category[i].tag === selected.submenus[j]) {
          categories.push({
            ...state.category[i],
            checked: true
          })
          selectedCategoriesCheck = true;
          break;
        } else {
          selectedCategoriesCheck = false;
        }
      }
      if(selectedCategoriesCheck === false) {
        categories.push({
          ...state.category[i],
          checked: false
        })
      }

    }
  } else {
    categories = state.category;
  }
  return categories;
});
const getValidAll = createSelector(
  entitySelectors.selectAll,
  asyncActionStateSelectors.getHasError,
  asyncActionStateSelectors.getSuccess,
  (revotes, hasError, success) => (!hasError && success ? revotes : null)
);
const getSearchFilter = createSelector(getState, (state: MasterMenuState) => state.searchFilter);
const getFilteredRevotes = createSelector(
  getValidAll,
  getSearchFilter,
  (revotes: any[], filter: SearchFilter) => {
    const useFilter =
      RA.isNotNilOrEmpty(filter) && RA.isNonEmptyString(filter.key) && RA.isNotNil(filter.value);

    const filterString = Array.isArray(filter?.value)
      ? (filter?.value as string[]).join(',').toLowerCase()
      : filter?.value
        ? (filter?.value.toLowerCase() as string)
        : '';
    return RA.isNotNilOrEmpty(revotes) && useFilter ? revotes.filter(option => option.name.toLowerCase().includes(filterString)) : revotes;
  }
);

export const MasterMenuSelectors = {
  entitySelectors,
  ...asyncActionStateSelectors,
  getInitSize,
  getSelectedTag,
  getSelected,
  getValidAll,
  getSearchFilter,
  getFilteredRevotes,
  getAllCategories,
  getAllLocations,
};
